/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Xaero Zero - xaerozero@icloud.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {ViewChild, HostListener, ComponentRef, ViewContainerRef, Input, ComponentFactoryResolver, Component} from '@angular/core';
import {Stage, Report} from '../../../../../model';
import {StageInfoContentComponent} from '../stage-info-content/stage-info-content.component';

@Component({
  selector: 'stage-info',
  templateUrl: 'stage-info.component.html',
  styleUrls: ['stage-info.component.scss']
})
export class StageInfoComponent {
  @ViewChild('target', { read: ViewContainerRef }) target: ViewContainerRef;
  @Input() stage: Stage;
  @Input() currentStage: Stage;
  @Input() currentReport: Report;
  @Input() stageList: Stage[];
  @Input() compact = false;

  private tooltip: ComponentRef<StageInfoContentComponent>;
  private visible: boolean;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private resolver: ComponentFactoryResolver
  ) {
  }

  @HostListener('focusin')
  @HostListener('mouseenter')
  showInfo(): void {
    if (this.visible || !this.stage.hasTransitions())
      return;

    this.visible = true;
    const factory = this.resolver.resolveComponentFactory(StageInfoContentComponent);

    this.tooltip = this.target.createComponent(factory);
    this.tooltip.instance.hostElement = this.viewContainerRef.element.nativeElement;
    this.tooltip.instance.history = this.stage.HISTORY;
    this.tooltip.instance.stages = this.stageList;
    this.tooltip.instance.stage = this.stage;
    this.tooltip.instance.currentReport = this.currentReport;
  }

  @HostListener('focusout')
  @HostListener('mouseleave')
  hideInfo(): void {
    if (!this.visible)
      return;

    this.visible = false;
    if (this.tooltip)
      this.tooltip.destroy();
  }
}
